import { render, staticRenderFns } from "./tempIndex.vue?vue&type=template&id=efd2bf52&scoped=true&"
import script from "./tempIndex.vue?vue&type=script&lang=js&"
export * from "./tempIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd2bf52",
  null
  
)

export default component.exports